"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("./constants");

/**
 * Gets the selected theme from storage
 * @returns {themePropType}
 */
var getSelectedTheme = function getSelectedTheme() {
  try {
    if (window && window.sessionStorage) {
      return JSON.parse(window.sessionStorage.getItem(_constants.CX_SELECTED_THEME));
    } else {
      return null;
    }
  } catch (_unused) {
    return null;
  }
};

var _default = getSelectedTheme;
exports.default = _default;